import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { AppProviders } from './providers';
import { AppRoutes } from './routes';

export function App() {
  return (
    <AppProviders>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </AppProviders>
  );
}
